import {
  ADD_NEW_PAYTO_ACCOUNT_MAX_AMOUNT_DEFAULT,
  MAX_AMOUNT_OPTION_DATA,
  PAYTO_LOG_TAG,
} from 'features/to/const';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useAddTransaction from 'hooks/form-add-transaction/useAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import usePage from 'hooks/usePage';
import { isEmpty } from 'lodash';
import React from 'react';

const withRoundUpPaytoMaxAmount = (Component) => {
  const RoundUpPaytoMaxAmountComponent = (props) => {
    const {
      isPaytoMaxAmountEdited,
      maxAmount,
      isAccountAgreementEditing,
      paytoAccountInformation,
    } = usePaytoStore();
    const { isAddTransactionPage } = usePage();
    const { getTotalToPay } = useAddTransaction();
    const { getTotalPayAmount } = useFxFormAddTransactionStore();

    const totalToPay = isAddTransactionPage
      ? getTotalToPay()
      : getTotalPayAmount();

    const getAmountRoundUp = (number) => {
      if (isPaytoMaxAmountEdited && Number(maxAmount) >= totalToPay) {
        return maxAmount;
      }
      return Math.ceil(number / 1000) * 1000; // roundUpToNearestThousand
    };
    const getMaxAmountInitial = () => {
      if (
        !isPaytoMaxAmountEdited &&
        totalToPay <= ADD_NEW_PAYTO_ACCOUNT_MAX_AMOUNT_DEFAULT
      ) {
        return ADD_NEW_PAYTO_ACCOUNT_MAX_AMOUNT_DEFAULT;
      }
      return getAmountRoundUp(totalToPay);
    };

    const getAmountRoundUpVer2 = (maxAmount) => {
      if (isAccountAgreementEditing) {
        const isMaxAmountValid = !isEmpty(
          MAX_AMOUNT_OPTION_DATA?.find(
            (item) => Number(item.value) === maxAmount
          )
        );
        let maxAmountEdit =
          Number(maxAmount) >= totalToPay
            ? isMaxAmountValid
              ? Number(maxAmount)
              : MAX_AMOUNT_OPTION_DATA?.find(
                  (item) => Number(item.value) >= Number(maxAmount)
                )?.value || ADD_NEW_PAYTO_ACCOUNT_MAX_AMOUNT_DEFAULT
            : MAX_AMOUNT_OPTION_DATA?.find(
                (item) => Number(item.value) >= totalToPay
              )?.value || ADD_NEW_PAYTO_ACCOUNT_MAX_AMOUNT_DEFAULT;
        if (maxAmountEdit > ADD_NEW_PAYTO_ACCOUNT_MAX_AMOUNT_DEFAULT) {
          maxAmountEdit = ADD_NEW_PAYTO_ACCOUNT_MAX_AMOUNT_DEFAULT;
        }
        console.log(
          `⭐ ${PAYTO_LOG_TAG} 👉 getAmountRoundUpVer2 ➡️ maxAmountEdit ↩`,
          maxAmountEdit
        );
        return maxAmountEdit;
      }
      const maxAmountInitial =
        MAX_AMOUNT_OPTION_DATA?.find((item) => Number(item.value) >= totalToPay)
          ?.value || ADD_NEW_PAYTO_ACCOUNT_MAX_AMOUNT_DEFAULT;
      console.log(
        `⭐ ${PAYTO_LOG_TAG} 👉 getAmountRoundUpVer2 ➡️ maxAmountInitial ↩`,
        maxAmountInitial
      );
      return maxAmountInitial;
    };
    const getMaxAmountInitialVer2 = () => {
      return getAmountRoundUpVer2();
    };

    const newProps = {
      ...props,
      maxAmountInitial: getMaxAmountInitial(),
      getAmountRoundUp,
      maxAmountInitialVer2: getMaxAmountInitialVer2(),
      getAmountRoundUpVer2,
      totalToPay,
    };
    return <Component {...newProps} />;
  };
  return RoundUpPaytoMaxAmountComponent;
};

export default withRoundUpPaytoMaxAmount;
